export default "__VITE_ASSET__DHWTe7Mb__"